import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";
import sass from "../assets/sass.png";
import java from "../assets/java.png";
import mysql from "../assets/mysql.png";
import bootstrap from "../assets/bootstrap.png";
import python from "../assets/python.png";
import linux from "../assets/linux.png";
import aws from "../assets/aws.png";
import ansible from "../assets/ansible.png";
import jenkins from "../assets/jenkins.png";
import docker from "../assets/docker.png";
import kubernetes from "../assets/kubernetes.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";
import about05 from "../assets/about05.jpg";
import about06 from "../assets/about06.png";

import profile from "../assets/profile.png";
import profileImage from "../assets/profile-image.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

import adidas from "../assets/adidas.png";
import amazon from "../assets/amazon.png";
import asus from "../assets/asus.png";
import nb from "../assets/nb.png";

export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  python,
  react,
  sass,
  java,
  mysql,
  linux,
  aws,
  ansible,
  jenkins,
  docker,
  kubernetes,
  bootstrap,
  about01,
  about02,
  about03,
  about04,
  about05,
  about06,
  profile,
  profileImage,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  nb,
};
